import {HoistService, XH} from '@xh/hoist/core';
import {getDefaultOptions} from '../../core/ServiceUtils';

export class ChartService extends HoistService {
    async fetchTimeSeriesAsync(ticker: string, fetchOpts = getDefaultOptions()): Promise<number[][]> {
        return XH.fetchService.fetchJson({
            url: `${XH.getConf('svcApiUrl')}/charts/${ticker}/timeseries`,
            method: 'GET',
            ...fetchOpts
        });
    }
}
